import React from "react";

export default class ModalAddUserHeader extends React.Component {

    componentDidMount() {
        if (this.input) this.input.focus();
    }

    render() {
        return (
            <div className="header">
                <div className="title">Add user</div>
                <div className="search">

                    <input ref={r=>this.input = r}
                           type="input"
                           className=""
                           value={this.props.search}
                           onChange={this.props.onSearchChange}
                           placeholder="Search" />

                    <div className="i5-search"> </div>

                    {!!this.props.search &&
                    <div className="i5-delete" onClick={this.props.onSearchCancel}> </div>}

                </div>

                <div className="i5-delete" onClick={this.props.closeModal}/>
            </div>
        )
    }
}